import React, { useState, useEffect, useContext, createRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row,
  Card,
  CardBody,
  Table,
  Media,
  Badge,
} from "reactstrap";
import SpareService from "./SpareService";
//import SpareReserve from '../Strategy/SpareService'
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { EnterpriseNameContext } from "../../context/EnterpriseContext";
import OrderService from "../Orders/OrderService";
import { UserType } from "../../context/UserType";
import Spare_Reserve_Service from "../Orders/Spare_Reserve_Service";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import swal from "sweetalert";
import NotificationAlert from "react-notification-alert";
// import { useHistory } from "react-router-dom";
import { CartContext } from "../../context/Cart";

const notification = createRef();

function ExitSpare(props) {
  const {
    // buttonLabel,
    className,
  } = props;

  const { setSpare } = useContext(CartContext);

  // const history = useHistory();
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const { enterpriseName } = useContext(EnterpriseNameContext);
  const { userType } = useContext(UserType);

  const [order, setOrder] = useState([]);
  const [equipamento, setEquipamento] = useState([]);
  const [descricao, setDescricao] = useState([]);
  const [responsavel, setResponsavel] = useState([]);
  const [idOrder, setIdOrder] = useState();
  const [spareReserve, setSpareReserve] = useState([]);
  const [setorInstalado, setSetorInstalado] = useState();
  const [orderStatus, setOrderStatus] = useState(false);
  const [nameUser] = useState(() => {
    const userNameStoraged = window.localStorage.getItem("TOKEN_USERNAME");

    if (userNameStoraged) {
      return userNameStoraged;
    }
    return;
  });

  const notifyCode = (event, title, content) => {
    let options = {
      place: "tc",
      message: (
        <div>
          <h2
            style={{ color: "#fff", marginBottom: "0" }}
            className="alert-title"
            data-notify="title"
          >
            {" "}
            {title ? title : "Atenção!"}
            <br />
          </h2>
          <span data-notify="message">
            {content ? content : "Este código já foi cadastrado!"}
          </span>
        </div>
      ),
      type: event,
      // icon: "ni ni-bell-55",
      autoDismiss: 4,
    };
    notification.current.notificationAlert(options);
  };

  useEffect(() => {
    OrderService.getOrders({ empresa: enterpriseName }).then((res) =>
      setOrder(res.data.data)
    );
  }, [enterpriseName]);

  const GreenCheckbox = withStyles({
    root: {
      color: green[400],
      "&$checked": {
        color: green[600],
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

  function Order_selected(order_id) {
    if (order_id) {
      setIdOrder(order_id);
      Spare_Reserve_Service.getSparesReserve({
        empresa: enterpriseName,
        ordem_id: order_id,
      }).then((response) => {
        const sparereserve = response.data;
        setSpareReserve(response.data);
        const verifyAllProvided =
          sparereserve.length > 0 &&
          sparereserve.every(
            (spareReserve) => spareReserve.status === "Entregue"
          );
        if (verifyAllProvided) {
          const updateOrder = {
            stateMaterialProvided: true,
          };
          OrderService.updateOrder(updateOrder, order_id).then(
            async (response) => {
              const res = await SpareService.getSpares({
                empresa: enterpriseName,
              });
              setSpare(res?.data?.data);
            }
          );
        }
      });
      OrderService.getOrderById(order_id).then((res) => {
        let orders = res.data.data;
        setEquipamento(orders.equipamento);
        // setArea(orders.area)
        setSetorInstalado(orders.setor_equipamento);
        setDescricao(orders.equipamento_denominacao);
        setResponsavel(orders.responsavel);
      });
    }
  }

  // Re-busca as reservas da ordem e os spares a partir do servidor (fonte da
  // verdade) e atualiza a flag de ordem stateMaterialProvided. NÃO muta estoque:
  // a baixa física, o status da reserva e o movimento são feitos no backend
  // (deliver/undo-deliver) de forma atômica.
  const refreshAfterStatusChange = () => {
    Spare_Reserve_Service.getSparesReserve({
      empresa: enterpriseName,
      ordem_id: idOrder,
    }).then((response) => {
      setSpareReserve(response.data);
      const allDelivered =
        response.data.length > 0 &&
        response.data.every((spareReserve) => spareReserve.status === "Entregue");
      OrderService.updateOrder(
        { stateMaterialProvided: allDelivered },
        idOrder
      );
    });
    SpareService.getSpares({ empresa: enterpriseName })
      .then((response) => {
        const spares = response?.data?.data;
        setSpare(spares);
        if (props.setSpare) props.setSpare(spares);
      })
      .catch(() => {});
  };

  // Entrega (Reservado -> Entregue) ou estorno da entrega (Entregue -> Reservado).
  // Toda a contabilização de estoque é transacional no servidor.
  const statusReserva = (reserva) => {
    const isReservado = reserva.status === "Reservado";
    const confirmMsg = isReservado
      ? `Confirmar a entrega do material ${reserva.produto}?`
      : `Deseja desfazer a entrega do produto ${reserva.produto}?`;
    const successMsg = isReservado
      ? "Material entregue com sucesso!"
      : "Entrega cancelada com sucesso!";

    swal(confirmMsg, "", "warning", {
      buttons: {
        nope: { text: "Me enganei!", value: "nope" },
        sure: { text: "Sim, claro.", value: "sure" },
      },
    }).then((value) => {
      if (value !== "sure") {
        if (value === "nope") swal("Operação cancelada", "", "success");
        return;
      }

      const action = isReservado
        ? Spare_Reserve_Service.deliver(reserva._id, nameUser)
        : Spare_Reserve_Service.undoDeliver(reserva._id, nameUser);

      action
        .then(() => {
          swal(successMsg, "", "success");
          refreshAfterStatusChange();
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            "Não foi possível concluir a operação.";
          swal(message, "", "error");
        });
    });
  };

  return (
    <div>
      {userType !== "Executante" && userType !== "Requisitante" ? (
        <>
          <Button
            color="success"
            size="sm"
            className="position-absolute top-3 right-4"
            onClick={toggle}
          >
            {" "}
            Saída de material{" "}
          </Button>
        </>
      ) : null}
      <Modal
        isOpen={modal}
        toggle={toggle}
        className={className}
        size="lg"
        className="mr-0 mt--1 mb--1 mt-5"
      >
        <NotificationAlert ref={notification} />
        <ModalHeader toggle={toggle} tag="h3" className="mt-3 mb--3">
          Saída de material
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <Autocomplete
              id="free-solo-demo"
              freeSolo
              options={order}
              getOptionLabel={(option) => {
                return (
                  option.id?.toString() +
                  " - " +
                  option.equipamento_denominacao?.toString()
                );
              }}
              onChange={(event, order) => {
                if (order) {
                  if (order.status === "Concluída") {
                    Order_selected(order._id);
                    setOrderStatus(true);
                  } else {
                    Order_selected(order._id);
                    setOrderStatus(false);
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Ordem de Manutenção"
                  margin="normal"
                  //variant="outlined"
                  placeholder="Insira o número da ordem de manutenção"
                />
              )}
            />
          </div>
          <h4>Resumo da Ordem </h4>
          <Card className="shadow-lg">
            <CardBody>
              <Row>
                <Col>
                  <p>
                    <b style={{ fontWeight: "550" }}>Area: </b> {setorInstalado}
                  </p>

                  <p>
                    <b style={{ fontWeight: "550" }}>Equipamento: </b>
                    {equipamento + " - " + descricao}
                  </p>

                  <p>
                    <b style={{ fontWeight: "550" }}>Executante: </b>
                    {responsavel}
                  </p>
                </Col>

                <Col className="col-auto">
                  <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                    <i className="ni ni-settings" />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <br></br>
          <h4> Materiais Reservados</h4>
          <Card className="shadow-lg">
            <CardBody>
              <Table className="align-items-center table-flush" responsive>
                <thead>
                  <tr>
                    <th scope="col">Material</th>
                    <th scope="col">Part Number</th>
                    <th scope="col">Quantidade</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {spareReserve &&
                    spareReserve.map((response, index) => {
                      return (
                        <tr key={index}>
                          <th scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {response.produto}
                                </span>
                              </Media>
                            </Media>
                          </th>

                          <th scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {response.part_number}
                                </span>
                              </Media>
                            </Media>
                          </th>
                          <th scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">
                                  {response.quantidade}
                                </span>
                              </Media>
                            </Media>
                          </th>

                          <th scope="row">
                            {orderStatus ? (
                              <Badge color="" className="badge-dot mr-4">
                                <GreenCheckbox
                                  checked={false}
                                  onChange={() =>
                                    notifyCode(
                                      "danger",
                                      "⚠ Atenção ⚠",
                                      "Essa ordem já foi concluída!"
                                    )
                                  }
                                  name="checkedG"
                                />
                                {response.status}
                              </Badge>
                            ) : (
                              <>
                                {response.status === "Reservado" ? (
                                  <Badge color="" className="badge-dot mr-4">
                                    <GreenCheckbox
                                      checked={false}
                                      onChange={() => statusReserva(response)}
                                      name="checkedG"
                                    />
                                    {response.status}
                                  </Badge>
                                ) : (
                                  <Badge color="" className="badge-dot">
                                    <GreenCheckbox
                                      checked={true}
                                      onChange={() => statusReserva(response)}
                                      name="checkedG"
                                    />
                                    {response.status}
                                  </Badge>
                                )}
                              </>
                            )}
                          </th>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
          <Button style={{ marginTop: "1em" }} color="success" onClick={toggle}>
            Confirmar
          </Button>{" "}
          <Button
            style={{ marginTop: "1em" }}
            color="secondary"
            onClick={toggle}
          >
            Cancelar
          </Button>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ExitSpare;
